import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomProductFacetNavigationComponent } from './product-facet-navigation.component';
import { IconModule } from '@spartacus/storefront';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CustomFacetListModule } from './facet-list/facet-list.module';

@NgModule({
  imports: [
    CommonModule,
    CustomFacetListModule, // FacetListModule,
    IconModule,
    I18nModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        ProductRefinementComponent: {
          component: CustomProductFacetNavigationComponent,
        },
      },
    }),
  ],
  declarations: [CustomProductFacetNavigationComponent],
  exports: [CustomProductFacetNavigationComponent],
})
export class CustomProductFacetNavigationModule {}
